import {useMemo} from 'react';
import {useAppContext} from '@/matic/providers/AppProvider';
import {
  canHardDelete,
  canManageCategories,
  canManageFiles,
} from '../authz/permissions';

/**
 * Memoized file permission flags derived from the current user's role.
 *
 * Replaces the scattered `canManageFiles(user!)` call pattern — callers should
 * import this hook instead of calling the permission functions directly, so the
 * non-null assertion and manual memoization are centralised here.
 */
export function useFilePermissions() {
  const {user} = useAppContext();
  return useMemo(
    () => ({
      /** Normal+ users can upload, rename, delete, and manage associations. */
      canManage: Boolean(user && canManageFiles(user)),
      /** Quality/Admin users can create, edit, and deactivate categories. */
      canManageCategories: Boolean(user && canManageCategories(user)),
      /** Quality/Admin users can permanently (hard) delete files. */
      canHardDelete: Boolean(user && canHardDelete(user)),
    }),
    [user]
  );
}
